import { render } from "./MainDashHome.vue?vue&type=template&id=1374617f"
import script from "./MainDashHome.vue?vue&type=script&lang=js"
export * from "./MainDashHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__